module.exports = __webpack_public_path__ + "3d288c91ede1a4e163a0c22b5b86b13c.svg";